import {
  emptyPlaceholder
} from "./L3SSPJS5.jsx";

// src/utils/tools.ts
import Decimal from "decimal.js";
var getDecimalPlaces = (value) => {
  if (value == null || value === "") return 0;
  const decimal = new Decimal(value);
  return decimal.decimalPlaces();
};
function currency(value, option) {
  const result = Number(value).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...option
  });
  return Number.isNaN(Number(value)) ? emptyPlaceholder : result;
}
var magicTag = (tag) => {
  return `magic-ui-${tag}`;
};

export {
  getDecimalPlaces,
  currency,
  magicTag
};
